import axios from 'axios'

import {
  AnswerAllocation,
  AnswerGaborGranger,
  AnswerIdeaPresenter,
  AnswerMatrix,
  AnswerMultipleChoice,
  AnswerOpenEnded,
  AnswerRanking,
  AnswerScale,
  User,
} from 'types/glass-api/domainModels'
import { getAPIUrl } from './baseAPI'

export interface SubmitAnswers {
  data: {
    answers: (
      | AnswerAllocation
      | AnswerGaborGranger
      | AnswerIdeaPresenter
      | AnswerMatrix
      | AnswerMultipleChoice
      | AnswerOpenEnded
      | AnswerRanking
      | AnswerScale
    )[]
    timeToComplete: number | null
  }
  surveyHash: string
}

export type SubmitAnswersResponse =
  | { points: number; redirect: boolean; totalPoints: number; user: User }
  | {
      qualify: boolean
      redirect: boolean
      success: boolean
      user: User
    }

export const SUBMIT_ANSWERS = ({
  surveyHash,
}: Pick<SubmitAnswers, 'surveyHash'>) => ({
  path: `/answers/${surveyHash}`,
  version: 'v1' as const,
})

export async function submitAnswers({ data, surveyHash }: SubmitAnswers) {
  return (
    await axios.post<SubmitAnswersResponse>(
      getAPIUrl(SUBMIT_ANSWERS({ surveyHash })),
      data,
    )
  ).data
}
